import axios from 'axios'
import config from '../config/app'
const VERSION = '/v2'

const contributionAPI = {
  /**
   * Base method for get contributions
   * @param params
   * @param additional
   * @returns {Promise}
   */
  get (params, additional, user = null) {
    if (additional !== null && additional !== undefined) {
      params.additional = additional.join(',')
    }
    let stringParams = Object.keys(params).filter((i) => { return params[i] !== '' && params[i] !== null }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => { return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m]) }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')
    let url = ''
    if (user) {
      url = config.server + VERSION + '/guest' + '/contribution?' + stringParams
    } else {
      url = config.server + VERSION + '/contribution?' + stringParams
    }
    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getNew (params, additional, user = null) {
    if (additional !== null && additional !== undefined) {
      params.additional = additional.join(',')
    }
    let stringParams = Object.keys(params).filter((i) => { return params[i] !== '' && params[i] !== null }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => { return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m]) }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')
    let url = ''
    if (user) {
      url = config.server + VERSION + '/guest' + '/contribution?' + stringParams
    } else {
      url = config.server + VERSION + '/contribution' + '/contributionNew?' + stringParams
    }
    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getImpactHistory (params, additional, user = null) {
    if (additional !== null && additional !== undefined) {
      params.additional = additional.join(',')
    }
    let stringParams = Object.keys(params).filter((i) => { return params[i] !== '' && params[i] !== null }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => { return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m]) }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')
    let url = ''
    url = config.server + VERSION + '/impact-history?' + stringParams
    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getPartnerImpactHistory (params, additional, user = null) {
    if (additional !== null && additional !== undefined) {
      params.additional = additional.join(',')
    }
    let stringParams = Object.keys(params).filter((i) => { return params[i] !== '' && params[i] !== null }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => { return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m]) }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')
    let url = ''
    url = config.server + VERSION + '/partner-impact-history?' + stringParams
    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getImpactHistoryGuest (params, additional, user = null) {
    if (additional !== null && additional !== undefined) {
      params.additional = additional.join(',')
    }
    let stringParams = Object.keys(params).filter((i) => { return params[i] !== '' && params[i] !== null }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => { return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m]) }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')
    let url = ''
    url = config.server + VERSION + '/guest/impact-history?' + stringParams
    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getImpactHistoryCsv (params, additional, user = null) {
    if (additional !== null && additional !== undefined) {
      params.additional = additional.join(',')
    }
    let stringParams = Object.keys(params).filter((i) => { return params[i] !== '' && params[i] !== null }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => { return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m]) }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')
    let url = ''
    url = config.server + VERSION + '/impact-history-csv?' + stringParams
    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getBusinessContribution (params, additional, user = null) {
    if (additional !== null && additional !== undefined) {
      params.additional = additional.join(',')
    }
    let stringParams = Object.keys(params).filter((i) => { return params[i] !== '' && params[i] !== null }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => { return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m]) }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')
    let url = ''
    url = config.server + VERSION + '/business-contribution?' + stringParams

    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getCsvExport (params, additional) {
    if (additional !== null && additional !== undefined) {
      params.additional = additional.join(',')
    }
    let stringParams = Object.keys(params).filter((i) => { return params[i] !== '' && params[i] !== null }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => { return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m]) }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')
    let url = config.server + VERSION + '/contribution/csvexportcontribution?' + stringParams

    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  createContributions (data) {
    return new Promise((resolve, reject) => {
      let url = config.server + VERSION + '/contribution'
      axios.post(url, data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  createContributionsToEngagement (data) {
    return new Promise((resolve, reject) => {
      let url = config.server + VERSION + '/engagement/contribution-engagement'
      axios.post(url, data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  sendShareSegment (shareData) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + VERSION + '/contribution/send-details', shareData).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  /**
   * ************************************ OLD APIs ************************************
   **/

  executePayment (contributionGroupId) {
    let url = config.server + '/contribution/pay'
    return new Promise((resolve, reject) => {
      axios.post(url, {contribution_group_id: contributionGroupId}).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getSum (type, filters) {
    let params = {type: type}
    if (typeof filters === 'object') {
      Object.keys(filters).map(function (key) {
        params[key] = filters[key]
      })
    }
    let stringParams = Object.keys(params).filter((i) => { return params[i] !== '' && params[i] !== null }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => { return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m]) }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')
    let url = config.server + '/contribution/sum?' + stringParams

    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  async getRemittances (filters, additional, isPDF) {
    let params = {}
    if (typeof filters === 'object') {
      Object.keys(filters).map(function (key) {
        params[key] = filters[key]
      })
    }
    if (additional !== null && additional !== undefined) {
      params.additional = additional.join(',')
    }
    let stringParams = Object.keys(params).filter((i) => { return params[i] !== '' && params[i] !== null }).map((k) => {
      if (k === 'date_start' || k === 'date_end') {
        let date = new Date(params[k])
        date = date.toISOString().slice(0, 10)
        return encodeURIComponent(k) + '=' + encodeURIComponent(date)
      } else {
        return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => { return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m]) }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
      }
    }).join('&')
    let url = config.server + '/user/contribution/remittances?is_pdf=' + isPDF + '&' + stringParams
    if (isPDF) {
      return new Promise(async (resolve, reject) => {
        axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
        axios.defaults.headers.common['Content-Type'] = 'application/pdf'
        await axios.get(url, {responseType: 'blob'}).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', filters['partner_user_name'] + '.pdf')
          document.body.appendChild(link)
          resolve(link.click())
        }, (error) => {
          reject(error)
        })
      })
    }

    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },

  async getRemittancesNew (filters, additional, isPDF) {
    let params = {}
    if (typeof filters === 'object') {
      Object.keys(filters).map(function (key) {
        params[key] = filters[key]
      })
    }
    if (additional !== null && additional !== undefined) {
      params.additional = additional.join(',')
    }
    let stringParams = Object.keys(params).filter((i) => { return params[i] !== '' && params[i] !== null }).map((k) => {
      if (k === 'date_start' || k === 'date_end') {
        let date = new Date(params[k])
        date = date.toISOString().slice(0, 10)
        return encodeURIComponent(k) + '=' + encodeURIComponent(date)
      } else {
        return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => { return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m]) }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
      }
    }).join('&')
    let url = config.server + '/user/contribution/remittances?is_pdf=' + isPDF + '&' + stringParams
    if (isPDF) {
      return new Promise(async (resolve, reject) => {
        axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
        axios.defaults.headers.common['Content-Type'] = 'application/zip'
        await axios.get(url).then((response) => {
          // const url = window.URL.createObjectURL(new Blob([response.data]))
          // const link = document.createElement('a')
          // link.href = url
          // link.setAttribute('download', filters['partner_user_name'] + '.zip')
          // document.body.appendChild(link)
          // resolve(link.click())
          // console.log(response)
          resolve(response.data)
        }, (error) => {
          reject(error)
        })
      })
    }

    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },

  /**
   * Get Remittances by partner_id
   *
   * @param userId
   * @returns {*|Promise}
   */
  getRemittancesByPartnerUserId (userId, additional) {
    return this.getRemittances({partner_user_id: userId}, additional)
  },

  /**
   * Get Contributions by partner_id
   *
   * @param userId
   * @param additionalFields
   * @param page
   * @param limit
   * @param filters
   * @returns {*|Promise}getByCompnayId
   */
  getContributionsByPartnerUserId (userId, additionalFields, filters) {
    let params = {}
    if (typeof filters === 'object') {
      Object.keys(filters).map(function (key) {
        params[key] = filters[key]
      })
    }
    params.partner_user_id = userId
    return this.get(params, additionalFields)
  },
  getRemittancesAdvice (params, user = null) {
    let stringParams = Object.keys(params).filter((i) => { return params[i] !== '' && params[i] !== null }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => { return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m]) }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')
    let url = ''
    url = config.server + '/user/contribution/remittence-advice?' + stringParams
    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getContributionsCsvExport (userId, additionalFields, filters) {
    let params = {}
    if (typeof filters === 'object') {
      Object.keys(filters).map(function (key) {
        params[key] = filters[key]
      })
    }
    params.partner_user_id = userId
    return this.getCsvExport(params, additionalFields)
  },
  /**
   *
   * @param userId
   * @returns {custom data}
   */
  getWCCounters (userid) {
    let url = config.server + '/user/contribution/getWCCounters?partner_user_id=' + userid

    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getChartContributionsByPartnerUserId (userId, additionalFields, filters) {
    let params = {}
    if (typeof filters === 'object') {
      Object.keys(filters).map(function (key) {
        params[key] = filters[key]
      })
    }
    params.partner_user_id = userId
    if (additionalFields !== null && additionalFields !== undefined) {
      params.additional = additionalFields.join(',')
    }
    let stringParams = Object.keys(params).filter((i) => {
      return params[i] !== '' && params[i] !== null
    }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => {
        return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m])
      }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')
    let url = config.server + '/user/contribution/getWCChartData?' + stringParams

    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getById (id, additional) {
    return new Promise((resolve, reject) => {
      this.get({id: id}, additional).then((response) => {
        if (response.data) {
          resolve(response.data[0])
        }
      }, (error) => {
        reject(error)
      })
    })
  },
  getContributions (params, additional) {
    if (additional !== null && additional !== undefined) {
      params.additional = additional.join(',')
    }
    let stringParams = Object.keys(params).filter((i) => { return params[i] !== '' && params[i] !== null }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => { return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m]) }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')
    let url = config.server + '/user/contribution/getContributions?' + stringParams
    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getByCurrentUser (filters, additional) {
    let params = {}
    if (typeof filters === 'object') {
      Object.keys(filters).map(function (key) {
        params[key] = filters[key]
      })
    }
    params.current_user = true
    return this.get(params, additional)
  },
  userImpactsGroupedByDates (userId, beginDate, endDate, type) {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/user/' + userId + '/impacts-grouped-by-date?begin_date=' + beginDate + '&end_date=' + endDate + '&type=' + type).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  statImpactByUser (userId, beginDate, endDate) {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/user/' + userId + '/stat-impacts?begin_date=' + beginDate + '&end_date=' + endDate).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  downloadGroupContributionsReceipt (contributionGroupId) {
    let url = config.server + '/contribution/receipt?group_id=' + contributionGroupId
    axios({
      url: url,
      method: 'GET',
      responseType: 'blob'
    }).then((response) => {
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(new Blob([response.data]), 'payment_receipt_' + contributionGroupId + '.pdf')
      } else {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'payment_receipt_' + contributionGroupId + '.pdf')
        document.body.appendChild(link)
        link.click()
        setTimeout(function () {
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
        }, 100)
      }
    })
  },
  downloadContributionReceipt (contributionId, contributionGroupId) {
    let headers = new Headers()
    let token = localStorage.getItem('token')
    headers.append('Authorization', 'Bearer ' + token)
    let file = config.server + '/contribution/' + contributionId + '/pdf'
    return fetch(file, {headers}).then(response => response.blob())
  },
  createB1G1Payment (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/contribution/b1g1', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  create (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/contribution', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  createContributionsNew (data) {
    return new Promise((resolve, reject) => {
      let token = localStorage.getItem('impersonate-token') !== null ? localStorage.getItem('impersonate-token') : localStorage.getItem('token')
      let url = config.server + VERSION + '/contribution'
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': token
      }
      axios.post(url, data, {
        headers: headers
      }).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },

  createFromCampaign (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/campaign/payment', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getTypes () {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/contribution/types').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  stat () {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/contribution/stat').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  downloadTaxClaimStatement (filters, userId, type) {
    let str = Object.keys(filters).map(function (key) {
      return key + '=' + filters[key]
    }).join('&')
    let headers = new Headers()
    let token = localStorage.getItem('token')
    headers.append('Authorization', token)
    let file = config.server + '/user/contribution/statement?user_id=' + userId + '&type=' + type + '&' + str
    return fetch(file, {headers}).then(response => response.blob())
  },
  deleteBatch (ids) {
    let promises = []
    ids.forEach((id) => {
      promises.push(this.delete(id))
    })
    return Promise.all(promises)
  },
  delete (id) {
    return new Promise((resolve, reject) => {
      axios.delete(config.server + '/contribution/' + id).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  changeStatus (id, status) {
    return new Promise((resolve, reject) => {
      // axios.post(config.server + '/user/contribution/' + id + '/status', {status: status}).then((response) => {
      axios.post(config.server + '/user/contribution/status/change', {status: status, ids: id}).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  changeStatusBatch (ids, status) {
    let promises = []
    ids.forEach((id) => {
      promises.push(this.changeStatus(id, status))
    })
    return Promise.all(promises)
  },
  /**
  *
  * @To get legency marker details
  * @param additional
  * @returns {*|Promise}
  */
  getLegacyMakers (currentDate) {
    let url = config.server + '/contribution/legacy-makers'
    return new Promise((resolve, reject) => {
      axios.post(url, {current_date: currentDate}).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  }
}

export default contributionAPI



// WEBPACK FOOTER //
// ./src/api/contribution.js